import { useState } from "react";
import { Card, CardBody, Col, Input, Row } from "reactstrap";

import { H4 } from "../../../../AbstractElements";
import Graph from "../../../../CommonElements/Graph";
import {
  Added,
  Advanced,
  CertifiedPercentage,
  Expert,
  Foundational,
  HeadCount,
  PreFoundational,
} from "../../../../utils/Constant";
import {
  headCountOptions,
  proficiencyLevelGraph,
} from "../../../../utils/helper/helper";

const CDPGraphType = () => {
  const [selectedHeaderCountDrop, setSelectedHeadCountDrop] = useState("all");
  const [selectedAddedCountDrop, setSelectedAddedCountDrop] = useState("all");

  const generateRandomData = (length = 12, min = 1, max = 100) => {
    return Array.from(
      { length },
      () => Math.floor(Math.random() * (max - min + 1)) + min
    );
  };

  const series1 = [
    {
      name: HeadCount,
      data: generateRandomData(),
    },
  ];

  const series2 = [
    {
      name: Added,
      data: generateRandomData(),
    },
  ];

  const series3 = [
    {
      name: PreFoundational,
      data: generateRandomData(),
    },
  ];

  const series4 = [
    {
      name: Foundational,
      data: generateRandomData(),
    },
  ];

  const series5 = [
    {
      name: Advanced,
      data: generateRandomData(),
    },
  ];

  const series6 = [
    {
      name: Expert,
      data: generateRandomData(),
    },
  ];
  const updatedOptions = {
    ...headCountOptions,
    dataLabels: {
      enabled: false,
      formatter: function (val) {
        return val.toFixed(2);
      },
      offsetY: -15,
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return val.toFixed(2);
        },
      },
      max: 100,
    },
  };

  return (
    <>
      <Row>
        <Col lg="6">
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <H4 className="mt-2">{HeadCount}</H4>
                </Col>
                <Col lg="8">
                  <Input
                    type="select"
                    value={selectedHeaderCountDrop}
                    onChange={e => {
                      setSelectedHeadCountDrop(e.target.value);
                    }}
                  >
                    {proficiencyLevelGraph?.map(option => (
                      <option key={option.id} value={option.id}>
                        {option.label}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>
              <Graph series={series1} options={updatedOptions} />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6">
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <H4 className="mt-2">{Added}</H4>
                </Col>
                <Col lg="8">
                  <Input
                    type="select"
                    value={selectedAddedCountDrop}
                    onChange={e => {
                      setSelectedAddedCountDrop(e.target.value);
                    }}
                  >
                    {proficiencyLevelGraph?.map(option => (
                      <option key={option.id} value={option.id}>
                        {option.label}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>
              <Graph series={series2} options={updatedOptions} />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Card>
        <CardBody>
          <H4 className="mb-3">{CertifiedPercentage}</H4>
          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  <H4 className="mb-3">{PreFoundational}</H4>
                  <Graph series={series3} options={updatedOptions} />
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                <CardBody>
                  <H4 className="mb-3">{Foundational}</H4>
                  <Graph series={series4} options={updatedOptions} />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <Card>
                <CardBody>
                  <H4 className="mb-3">{Advanced}</H4>
                  <Graph series={series5} options={updatedOptions} />
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                <CardBody>
                  <H4 className="mb-3">{Expert}</H4>
                  <Graph series={series6} options={updatedOptions} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default CDPGraphType;
